import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { PosTask } from "../../interfaces/Task";
import { Media } from "../../interfaces/Media";
import Uploader from "../../elements/Uploader";
import CustomEditor from "../../elements/CustomEditor";
import Help from "../../elements/HelpContent";
import { registerEventEnd, registerEventStart } from "../../../utils/utils";
import AITools from "../../elements/AITools";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

const emptyPosTask: any = {
    _id: '',
    name: '',
    type: 'explanationtext',
    instructions: '',
    media: [],
    text: '',
    updated: new Date()
}

export interface NewPosTaskExplanationTextProps {
    saveForm: CallableFunction;
    closeForm: CallableFunction;
    task_language?: string;
}

export default function NewPosTaskExplanationText(props: NewPosTaskExplanationTextProps) {
    const { t } = useTranslation();
    
    const [eventId, setEventId] = useState('');
    const [posTask, setPosTask] = useState<PosTask>(emptyPosTask);
    const [name, setName] = useState('');
    const [instructions, setInstructions] = useState('');
    const [teacher_notes, setTeacherNotes] = useState('');
    const [text, setText] = useState('');
    const [media, setMedia] = useState<Media[]>([]);

    const handleMediaUpload = (media: Media[]) => {
        const newMedia = media.map((m: Media) => {
            return m;
        });
        setMedia(newMedia);
    }

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    }

    const handleInstructionsChange = (data: string) => {
        setInstructions(data);
    }

    const handleTeacherNotesChange = (data: string) => {
        setTeacherNotes(data);
    }

    const handleTextChange = (data: string) => {
        setText(data);
    }

    const handleClose = () => {
        registerEventEnd(eventId);
        props.closeForm();
    }

    const handleSave = () => {
        if (name) {
            registerEventEnd(eventId);
            posTask.name = name;
            posTask.instructions = instructions;
            posTask.teacher_notes = teacher_notes;
            posTask.media = media.map((m: Media) => { return m; });
            posTask.text = text;
            props.saveForm(posTask);
        }
    }

    useEffect(() => {
        registerEventStart('new postask explanation', '').then(data => {
            setEventId(data);
        });
    }, []);

    useEffect(() => {
        return () => {
            if (eventId) {
                registerEventEnd(eventId);
            }
        };
    }, [eventId]);

    const doNothing = () => {
        
    }

    return(
        <Overlay
            title={t("New Post-Task: Explicit Explanation")}
            onClose={handleClose}
            className="new-task-container explicit-explanation"
            actions={[
                {
                    label: t("Cancel"),
                    variant: 'secondary',
                    onClick: handleClose
                },
                {
                    label: t("Save"),
                    variant: 'primary',
                    onClick: handleSave
                }
            ]}
        >
            <div className="inner">
                <h2>
                    { t("New Post-Task: Explicit Explanation") }
                    <Help id={ '653e6f4d8fb78d09dce645d3' } />
                </h2>
                <AITools />
                <Form className="new-post-task-form">
                    <div className="fields-container">
                        <Form.Group className="field field-title">
                            <Form.Label>{ t("Title of the Post-Task") }</Form.Label>
                            <Form.Control type="text" name="name" required value={ name } onChange={ handleNameChange } />
                        </Form.Group>
                        <div className="field field-instructions">
                            <CustomEditor
                                change={ handleInstructionsChange }
                                changeFormatted={ doNothing }
                                data={ '' }
                                formatted= { '' }
                                id="instructions"
                                label={ t("Aim and instructions") }
                                npl={ false }
                                task_id={ '' }
                                task_language={ props.task_language }
                            />
                        </div>
                        <div className="field field-teachernotes">
                            <CustomEditor
                                change={ handleTeacherNotesChange }
                                changeFormatted={ doNothing }
                                data={ '' }
                                formatted= { '' }
                                id="teachernotes"
                                label={ t("Teacher notes") }
                                npl={ false }
                                task_id={ '' }
                            />
                        </div>
                        <Uploader media={ media } save={ handleMediaUpload } />
                        <div className="field field-text">
                            <CustomEditor
                                change={ handleTextChange }
                                changeFormatted={ doNothing }
                                data={ '' }
                                formatted= { '' }
                                id="text"
                                label={ t("Text")}
                                npl={ false }
                                task_id={ '' }
                                task_language={ props.task_language }
                            />
                        </div>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}